import { getScale, getTopValue } from "../GelDragDrop.utils";
import { GEL_TYPE } from "../GelDragDrop.constants";

export function getStyle({ state, props }) {
  const scale = getScale(state);
  const height = getHeight(state.gelHolderBoxHeight, props.height);
  return {
    height: `${height}px`,
    left: "10%",
    top: `${getTopValue(scale(props.value), state)}px`,
    width: "80%",
    opacity: props.opacity,
    fontSize: `${getFontSize(height, props)}px`,
  };
}

const MAX_HEIGHT_VALUE = 100;
function getHeight(gelHolderBoxHeight, propHeight) {
  return (gelHolderBoxHeight * propHeight) / MAX_HEIGHT_VALUE - 2;
}

function getFontSize(height, props) {
  if (props.gelType === GEL_TYPE.LABEL) return 16;
  else return height - 1;
}
